import type { ReactNode } from 'react';
import { BlackWolfLogo, HelmWordmark } from '@/components/brand';

export function AuthLayout({
  title,
  subtitle,
  children,
  wide,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  wide?: boolean;
}) {
  return (
    <div className="flex min-h-full flex-col bg-bg">
      <div className="flex flex-1 items-center justify-center px-4 py-10">
        <div className={wide ? 'w-full max-w-[460px]' : 'w-full max-w-[380px]'}>
          <div className="mb-6 flex justify-center">
            <HelmWordmark variant="full" />
          </div>
          <div className="rounded-xl border border-border bg-surface p-7 shadow-sm">
            <h1 className="text-lg font-semibold">{title}</h1>
            {subtitle && <p className="mt-1 text-sm text-muted">{subtitle}</p>}
            <div className="mt-5">{children}</div>
          </div>
          <p className="mt-6 text-center text-xs leading-relaxed text-subtle">
            Program artifacts only. Do not enter borrower, loan-level or personal information.
          </p>
        </div>
      </div>
      <footer className="flex items-center justify-center gap-2 pb-6 text-xs text-subtle">
        <BlackWolfLogo className="scale-90 opacity-90" />
      </footer>
    </div>
  );
}
